import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">读者评论</h2>
          <p className="mt-1 text-sm text-foreground-500">来自漫画爱好者的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading font-bold text-sm">
                  {item.avatar}
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}